module.exports = __webpack_public_path__ + "img/wx-error-bg1.8bf768a3.png";